import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    notificationWrapper: {
      position: 'fixed',
      top: 100,
      zIndex: 1400,
      right: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    notification: {
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderGray60,
      height: 56,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shape.boxShadowLarge,
      padding: theme.spacing(0, 2),
      gap: theme.spacing(4),
    },
    notificationText: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    link: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
    },
    name: {
      fontWeight: theme.typography.fontWeightSemiBold,
    },
  }),
  {
    name: 'UpdatePersonaBrandVoiceNotification',
  }
);
